import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog';

export type LoginNotice = { title: string; body: string };

/**
 * 로그인 화면 팝업 — 연결 불안정 · SNS 로그인 실패 · 앱 가입 안내 (Figma 848:9233).
 * 공용 AlertDialog를 쓰되 로그인 디자인(가운데 정렬 · 큰 모서리)만 덮어쓴다.
 */
export const LoginNoticeDialog = ({
  notice,
  onClose,
}: {
  notice: LoginNotice | null;
  onClose: () => void;
}) => (
  <AlertDialog open={notice !== null} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent className="max-w-[328px] gap-6 rounded-[40px] border-[1.5px] border-[#f3f4f6] px-6 py-10">
      {notice && (
        <div className="flex flex-col gap-2 text-center">
          <AlertDialogTitle className="text-base leading-6 font-bold tracking-[-0.16px] text-[#131927]">
            {notice.title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-sm leading-[22px] font-medium tracking-[-0.112px] text-[#6d717f]">
            {notice.body}
          </AlertDialogDescription>
        </div>
      )}
      <AlertDialogFooter className="mt-0">
        <AlertDialogAction className="h-12 rounded-2xl bg-[#131927] text-base leading-5 font-semibold tracking-[-0.16px] hover:bg-[#131927]/90">
          확인
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
